export const mapPriorityNameByKey = {
  1: 'high',
  2: 'medium',
  3: 'low',
}

export const INCIDENT_TYPE = {
  MAIL: 1,
  ATO: 2,
  TEAMS: 3,
  POTENTIAL_MAIL: 4,
  ENCRYPTED_INCIDENT: 5,
  AUTO_THEMIS_POTENTIAL_MAIL: 6,
  MSFT: 7,
}

export const MAIL_BASED_INCIDENT_TYPE = [
  INCIDENT_TYPE.MAIL,
  INCIDENT_TYPE.POTENTIAL_MAIL,
  INCIDENT_TYPE.AUTO_THEMIS_POTENTIAL_MAIL,
]

export const CHALLENGED_INCIDENT_TYPE = {
  RELEASE_REQUEST: 1,
  ENCRYPTED_ATTACHMENT: 2,
  SAFE_CHALLENGED: 3,
}

export const MAP_INCIDENT_TYPE_TO_ICON_NAME = {
  [INCIDENT_TYPE.MAIL]: 'mail',
  [INCIDENT_TYPE.ATO]: 'ato',
  [INCIDENT_TYPE.TEAMS]: 'teams',
  [INCIDENT_TYPE.POTENTIAL_MAIL]: 'potential',
  [INCIDENT_TYPE.ENCRYPTED_INCIDENT]: 'mail',
  [INCIDENT_TYPE.AUTO_THEMIS_POTENTIAL_MAIL]: 'at_potential',
  [INCIDENT_TYPE.MSFT]: 'mail',
}

export const MAP_INCIDENT_TYPE_TO_NAME = {
  [INCIDENT_TYPE.MAIL]: 'mail',
  [INCIDENT_TYPE.ATO]: 'ato',
  [INCIDENT_TYPE.TEAMS]: 'teams',
  [INCIDENT_TYPE.POTENTIAL_MAIL]: 'potential_mail',
  [INCIDENT_TYPE.ENCRYPTED_INCIDENT]: 'encrypted',
  [INCIDENT_TYPE.AUTO_THEMIS_POTENTIAL_MAIL]: 'auto_themis_potential_mail',
  [INCIDENT_TYPE.MSFT]: 'msft',
}

const INCIDENT_TYPE_NAME = {
  MAIL: 'mail',
  ATO: 'ato',
  TEAMS: 'teams',
  POTENTIAL_MAIL: 'potential',
  ENCRYPTED_INCIDENT: 'encrypted',
  MSFT: 'msft',
}

export const MAP_INCIDENT_URL_TO_TYPE = {
  [INCIDENT_TYPE_NAME.MAIL]: INCIDENT_TYPE.MAIL,
  [INCIDENT_TYPE_NAME.ATO]: INCIDENT_TYPE.ATO,
  [INCIDENT_TYPE_NAME.TEAMS]: INCIDENT_TYPE.TEAMS,
  [INCIDENT_TYPE_NAME.POTENTIAL_MAIL]: INCIDENT_TYPE.POTENTIAL_MAIL,
  [INCIDENT_TYPE_NAME.ENCRYPTED_INCIDENT]: INCIDENT_TYPE.ENCRYPTED_INCIDENT,
  [INCIDENT_TYPE_NAME.MSFT]: INCIDENT_TYPE.MSFT,
}

export const MAP_INCIDENT_TYPE_TO_PREFIX = {
  [INCIDENT_TYPE.MAIL]: 'IS',
  [INCIDENT_TYPE.ATO]: 'ATO',
  [INCIDENT_TYPE.TEAMS]: 'MST',
  [INCIDENT_TYPE.POTENTIAL_MAIL]: 'BUP',
  [INCIDENT_TYPE.ENCRYPTED_INCIDENT]: 'ENC',
  [INCIDENT_TYPE.AUTO_THEMIS_POTENTIAL_MAIL]: 'BUP',
  [INCIDENT_TYPE.MSFT]: 'MSFT',
}

export const MAP_INCIDENT_TYPE_TO_URL_PREFIX = {
  [INCIDENT_TYPE.MAIL]: INCIDENT_TYPE_NAME.MAIL,
  [INCIDENT_TYPE.ATO]: INCIDENT_TYPE_NAME.ATO,
  [INCIDENT_TYPE.TEAMS]: INCIDENT_TYPE_NAME.TEAMS,
  [INCIDENT_TYPE.POTENTIAL_MAIL]: INCIDENT_TYPE_NAME.POTENTIAL_MAIL,
  [INCIDENT_TYPE.ENCRYPTED_INCIDENT]: INCIDENT_TYPE_NAME.ENCRYPTED_INCIDENT,
  [INCIDENT_TYPE.AUTO_THEMIS_POTENTIAL_MAIL]: INCIDENT_TYPE_NAME.POTENTIAL_MAIL,
  [INCIDENT_TYPE.MSFT]: INCIDENT_TYPE_NAME.MSFT,
}

export const prefixToName = Object.entries(MAP_INCIDENT_TYPE_TO_PREFIX).reduce(
  (acc, [typeKey, prefix]) => {
    acc[prefix] = MAP_INCIDENT_TYPE_TO_NAME[typeKey]
    return acc
  },
  {}
)

export const GENERAL_FILTER_OPTIONS = [
  { value: 0, label: 'All' },
  { value: 11, label: 'Resolved Automatically' },
  { value: 10, label: 'Resolved Manually' },
  { value: 5, label: 'Include Links' },
  { value: 6, label: 'Include Fake Login' },
  { value: 7, label: 'Include Attachments' },
  { value: 8, label: 'Include Internal Comments' },
]

export const EXCLUDING_THEMIS_SPAM_SAFE_OPTION = {
  value: 12,
  label: 'Excl. Themis Spam & Safe verdict',
}

export const GENERAL_FILTER_STARTER_OPTIONS = [
  { value: 0, label: 'All' },
  { value: 5, label: 'Include Links' },
  { value: 7, label: 'Include Attachments' },
  { value: 8, label: 'Include Internal Comments' },
]

export const DERIVED_FROM_SIGHTS_CHOICES = {
  7: 'FROM_VIP_IMPERSONATION',
  14: 'FROM_BEC_DETECTION',
  15: 'FROM_BULK_PHISHING_DETECTION',
}

export const DERIVED_FROM = {
  FEDERATION: 2,
  THIRD_PARTY_SCANNERS: 4,
  CACHED_SCANNERS: 5,
}

export const NAME_FOR_HISTORY_STORE = 'rcReports'
